<!-- Service Request General Information -->
<div class="hcol-flex gap-half">
    @if (showLoading) {
        <div class="text-center">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" animationDuration="1.5s"></p-progressSpinner>
            <div class="mt-2 mb-2">{{ loadingStr }}</div>
        </div>
    } @else if (serviceRequest) {
        <!-- Left Column: Service Request Info + Editable Fields -->
        <div class="hcol-grow">
            <p-panel>
                <ng-template pTemplate="header">
                    <div class="hcol-grow" style="display: flex; align-items: center; gap: 0.5rem">
                        <span class="p-panel-title">Service request information</span>
                        @if (canEditServiceRequest) {
                            <p-button
                                size="small"
                                severity="secondary"
                                icon="pi pi-pencil"
                                (onClick)="openServiceRequestEditModal()"
                                pTooltip="Edit Service Request"
                                tooltipPosition="bottom"
                            />
                        }
                    </div>
                </ng-template>

                <div style="display: flex; flex-direction: column; height: calc(100vh - 20rem)">
                    <div class="hcol-flex gap-half w-100 space-around-start mt-3">
                        <!-- Organization -->
                        <div style="display: flex; gap: 0.5rem; align-items: center">
                            <span class="text-bold">Organization</span>
                            @if (serviceRequest.organization) {
                                <span>{{ serviceRequest.organization.name }}</span>
                                <p-button
                                    severity="secondary"
                                    size="small"
                                    icon="pi pi-external-link"
                                    (click)="openOrganizationModal()"
                                />
                            } @else {
                                <span><i>No organization...</i></span>
                            }
                        </div>

                        <!-- Project -->
                        <div style="display: flex; gap: 0.5rem; align-items: center">
                            <span class="text-bold">Project</span>
                            @if (serviceRequest.project) {
                                <span>{{ serviceRequest.project.name }}</span>
                                <p-button
                                    severity="secondary"
                                    size="small"
                                    icon="pi pi-external-link"
                                    (click)="openProjectModal()"
                                />
                            } @else {
                                <span><i>No project...</i></span>
                            }
                        </div>

                        <!-- Group -->
                        <div style="display: flex; gap: 0.5rem; align-items: center">
                            <span class="text-bold">Group</span>
                            @if (serviceRequest.service_request_group) {
                                <span>{{ serviceRequest.service_request_group.name }}</span>
                                <p-button
                                    severity="secondary"
                                    size="small"
                                    icon="pi pi-external-link"
                                    (click)="openGroupModal()"
                                />
                            } @else {
                                <span><i>No group...</i></span>
                            }
                        </div>

                        <div class="hcol-grow"></div>

                        <!-- Created by/at section -->
                        <div class="align-h">
                            <i class="pi pi-user me-1"></i>
                            <span class="text-bold">Created by</span> {{ createdByUser?.email || '--' }}
                            <span class="text-bold">at</span> {{ serviceRequest.created_at | date: 'yyyy-MM-dd HH:mm' }}
                        </div>
                    </div>

                    <div class="w-100 mt-2" style="display: flex; flex-direction: column; flex-grow: 1; min-height: 0">
                        <div class="text-bold align-h mb-2">Description</div>
                        <div
                            class="p-3"
                            style="
                                border: 1px solid #dee2e6;
                                border-radius: 8px;
                                white-space: pre-wrap;
                                flex-grow: 1;
                                overflow-y: auto;
                            "
                        >
                            <p>{{ serviceRequest.description || 'No description...' }}</p>
                        </div>
                    </div>
                </div>
            </p-panel>
        </div>

        <!-- Right Column: Overview Statistics -->

        <div [style.width]="'8rem'">
            <p-panel header="Overview" class="title-center">
                <div class="vcol-flex space-around-center">
                    <div class="content-center">
                        <div class="content-center">
                            <span
                                pTooltip="Tasks/Groups"
                                tooltipPosition="left"
                                class="pi pi-list-check"
                                [style.fontSize]="'2.5rem'"
                            ></span>
                            <div>{{ tasksCount ?? '--' }}</div>
                            <p class="mb-0">Tasks/Groups</p>
                        </div>
                    </div>

                    <div class="content-center">
                        <div class="content-center">
                            <span
                                pTooltip="Files"
                                tooltipPosition="left"
                                class="pi pi-file"
                                [style.fontSize]="'2.5rem'"
                            ></span>
                            <div>{{ filesCount ?? '--' }}</div>
                            <p class="mb-0">Files</p>
                        </div>
                    </div>

                    <div class="content-center">
                        <span
                            pTooltip="Object Store Entry"
                            tooltipPosition="left"
                            class="pi pi-database"
                            [style.fontSize]="'2.5rem'"
                        ></span>
                        <div>{{ objectStoreCount ?? '--' }}</div>
                        <p class="mb-0">Object Store Entry</p>
                    </div>
                </div>
            </p-panel>
        </div>
    }
</div>
